import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';
import { Layout } from '../components/layout/layout.tsx';
import { ApplicationRoutes } from '../constants/appRoutes';

export const DevHiddenRoutes: RouteItem[] = [
  {
    text: 'SignalR Test',
    authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
    path: ApplicationRoutes.dev.signalrTest,
    allowedRoles: [],
    layout: <Layout />,
    async lazy() {
      const component = await import('../features/dev/signalrTest/SignalRTestPage.tsx');
      return { Component: component.default };
    }
  }
];
